export default __webpack_public_path__ + "static/media/logisticaParceiro.188ac6d6.svg";